export default function uqnJoin(array) {
    let n = array.length - 1, num = 0;
    array.forEach(e => {
        num += Number(e) * Math.pow(10, n);
        n--;
    });
    return num;
}
